import {ContentTileWithTitle} from '#/atoms/content-tile';
import {ActionMenuContext} from '#/components/actionmenu/action-menu';
import {
  ActionMenuContentSectionInfoRow,
  ActionMenuContentSectionInfoRowRentalYield,
} from '#/components/actionmenu/subcomponents';
import {ActionMenuSection} from '#/components/actionmenu/types';
import {SLQueryParamConfig} from '#/contexts/query-params-provider';
import {useCoinDisplayPreferences} from '#/hooks/use-coin-display-preferences';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {useQueryParams} from 'use-query-params';

export const ActionMenuContentSectionBalance: FunctionComponent = () => {
  const {t} = useTranslation('translation', {
    keyPrefix: 'pages.actionMenu.information.sections.information.contentSection.balance',
  });

  const {land, landMarketInfo, landAccountInfo} = useContext(ActionMenuContext);

  const [{action}] = useQueryParams<SLQueryParamConfig>();
  const displayPref = useCoinDisplayPreferences();

  return (
    <ContentTileWithTitle title={t('title')}>
      <div className='space-y-2'>
        <ActionMenuContentSectionInfoRow>
          {{
            left: t('infoRows.amount.title'),
            right: t('infoRows.amount.value', {
              currencySymbol: land.tokenSymbol,
              amount: landAccountInfo.landTokenAmount,
            }),
          }}
        </ActionMenuContentSectionInfoRow>
        <ActionMenuContentSectionInfoRow>
          {{
            left: t('infoRows.value.title'),
            right: t('infoRows.value.value', {
              currencySymbol: displayPref.symbol,
              amount: displayPref.displayAmount(landAccountInfo.landTokenMarketValue),
            }),
          }}
        </ActionMenuContentSectionInfoRow>
        {action === ActionMenuSection.RENT && (
          <div className='space-y-2'>
            <ActionMenuContentSectionInfoRow>
              {{
                left: t('infoRows.liquidity.title'),
                right: t('infoRows.liquidity.value', {
                  currencySymbol: landMarketInfo.lpSymbol,
                  amount: landAccountInfo.lpTokenAmount,
                }),
              }}
            </ActionMenuContentSectionInfoRow>
            <ActionMenuContentSectionInfoRowRentalYield land={land} />
          </div>
        )}
      </div>
    </ContentTileWithTitle>
  );
};
